import { useState, useEffect } from 'react';
import { useGetDataSource } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSource';
import { getToObjectType } from 'automation-ui-formula-editor/data-passing-panel/utils/getToObjectType';
import { useDataPassingContext } from 'automation-ui-formula-editor/data-passing-panel/DataPassingContext';
import { FETCHED_OBJECTS } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
export const useGetDataSourceFromToObjectId = ({
  prefix
}) => {
  const {
    state: dataPassingState
  } = useDataPassingContext();
  const {
    flowObjectTypeId
  } = dataPassingState;
  const [toObjectTypeId, setToObjectTypeId] = useState();
  const [loading, setLoading] = useState(true);
  const {
    data,
    loading: queryLoading
  } = useGetDataSource({
    prefix
  });
  useEffect(() => {
    if (prefix.startsWith(FETCHED_OBJECTS)) {
      return;
    }
    setToObjectTypeId(flowObjectTypeId);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!prefix.startsWith(FETCHED_OBJECTS) || !data || queryLoading) {
      return;
    }
    setToObjectTypeId(getToObjectType(data.dataSourceDefinition, flowObjectTypeId));
    setLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryLoading, data]);
  return {
    fromObjectTypeId: flowObjectTypeId,
    toObjectTypeId,
    loading
  };
};